module.exports = __webpack_public_path__ + "img/default_avatar_male_preview.11f65f06.png";